module.exports = __webpack_public_path__ + "static/02-0314928b3908d8b615b581e978397546.png";